export default __webpack_public_path__ + "static/media/authentication-bg-dark.2da49e1f.svg";